import { render, staticRenderFns } from "./resign-times.vue?vue&type=template&id=31fcc58c&scoped=true&"
import script from "./resign-times.vue?vue&type=script&lang=ts&"
export * from "./resign-times.vue?vue&type=script&lang=ts&"
import style0 from "./resign-times.vue?vue&type=style&index=0&id=31fcc58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fcc58c",
  null
  
)

export default component.exports